// extracted by mini-css-extract-plugin
export default {"ChangePasswordPage":"style_ChangePasswordPage__9SMLv"};